import { Actions, createEffect, ofType } from '@ngrx/effects';
import { Injectable } from '@angular/core';
import { ApiService } from '../../../services/api/api.service';
import { mergeMap } from 'rxjs/operators';
import { GetBijbEventAction } from '../../actions/bijb-event/get-event-action';
import { GetBijbEventErrorAction } from '../../actions/bijb-event/get-event-error-action';
import { GetBijbEventSuccessAction } from '../../actions/bijb-event/get-event-success-action';

@Injectable()
export class GetBijbEventEffect {
  constructor(private api: ApiService, private actions: Actions) {
  }


  public GetEventActions = createEffect(() => this.actions
    .pipe(
      ofType(GetBijbEventAction.type),
      mergeMap(action => {
        const getBijbEventAction = <GetBijbEventAction>action;
        return this.api.getEvent(getBijbEventAction.bijbEvent).then(event => {
          return new GetBijbEventSuccessAction(event);
        }, error => {
          return new GetBijbEventErrorAction(error);
        });
      })
    ));
}
